import React, { useEffect, useMemo, useState } from "react";
import { api } from "../../../config/api";
import styles from "../mainRedesign.module.scss";

export default () => {
  const [companies, setCompanies] = useState<string[]>([]);

  useEffect(() => {
    api
      .getCompanyNames()
      .then((result) => {
        const list: string[] = result.data.companies || [];
        if (list.length > 0) {
          setCompanies(list);
        }
      })
      .catch(() => {});
  }, []);

  const looped = useMemo(() => {
    if (companies.length === 0) return [];
    const display = companies.slice(0, 60);
    return [...display, ...display];
  }, [companies]);

  if (looped.length === 0) return null;

  return (
    <section className={styles.companySection}>
      <div className={styles.companyLabel}>서비스 이용 회원사</div>
      <div className={styles.companyMarqueeWrap}>
        <div className={styles.companyRow}>
          <div className={styles.companyTrack}>
            {looped.map((name, i) => (
              <span key={i} className={styles.companyChip}>
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
